<template>
  <transition name="slide">
    <div ref="box" class="user-info-box" :style="{ paddingBottom: bottomLink.img ? '.6rem' : 0 }">
      <div id="user-info" class="user-info" :style="{ 'background-color': haveWeight ? '#18bdef' : '#1fd2ba' }">
        <swiper :imgList="imgList" v-if="imgList.length > 0"></swiper>
        <div class="back"></div>
        <div class="user-content">
          <headers
            v-if="showRank"
            :webType="webType"
            :rankList="rankList"
            :rankTitle="rankTitle"
            :pagetype="pagetype"
            :showMyRank="showMyRank"
            :haveWeight="haveWeight"
            :myRank="myRank"
            :userImage="userImage"
          ></headers>
          <div class="user_info_box" v-else-if="showMyData" :style="{ height: showInfo ? '1.75rem' : '.54rem' }" @click="showInfo = !showInfo">
            <div class="user_info_title">
              <img src="/static/images/icons.png" class="top-img" />
              我的资料<span class="edit" @click="onClickEditInfo"></span>
            </div>
            <div class="user_info">
              <img class="avatar" :src="userImage" />
              <div>
                <p>性别：{{ myInfo.gender == 1 ? '男' : '女' }}</p>
                <p>身高：{{ myInfo.height }}</p>
                <p>生日：{{ computeBirthday }}</p>
              </div>
              <img class="background" src="/static/images/editBack.png" />
            </div>
          </div>

          <Measure v-if="haveWeight" :userWeight="userWeight" :weightTime="weightTime" :until="until" :score="score"></Measure>

          <div class="content-last" v-if="haveWeight">
            <div class="content-last-info">
              <div class="last-first">
                <span>健康报告</span>
                <span class="history-span" @click.stop="onClickHistory">
                  <img src="../../assets/images/data_history.png" />
                  历史数据
                </span>
              </div>
            </div>
            <!-- 插入位置 -->
            <healthReport :datas="datas" />
            <div class="all-bottom"></div>
          </div>
        </div>
        <!--<button class="btn-share tap-highlight" @click="onClickShare" v-if="haveWeight"></button>-->
      </div>
      <div class="last-message" v-show="bottomLink.img">
        <a class="tap-highlight" :href="bottomLink.url" :style="'background-image: url(' + bottomLink.img + ')'"></a>
      </div>
    </div>
  </transition>
</template>

<script>
import ajax from '@/common/js/common'
import swiper from '@/components/template/swiper'
import Headers from '@/components/template/my_info'
import Measure from '@/components/template/measure'
import healthReport from '@/components/template/healthReport'
import Decoder from '@/ble/decoder'
import api from '@/utils/api'
import { UrlParameter } from '@/utils/getUrl'
import { fillFlag } from '@/utils/util.js'

export default {
  name: 'userInfo',
  data() {
    return {
      userName: '',
      webType: 'user',
      code: '',
      msg: '',
      selected: 0,
      userInfo: [{ sex: '', height: '', birthday: '' }],
      userImage: '/static/images/header_1.png',
      userWeight: '',
      weightTime: '',
      until: '',
      indexData: [],
      indexDatas: [],
      myInfo: { brithday: new Date() },
      myDimension: [],
      datas: [],
      score: '',
      imgList: [],
      haveWeight: true, // 是否称重 否则显示测量排行与轮播
      loadMeasure: false,
      rankList: [],
      rankTitle: ['排名', '头像', '昵称', '分数'],
      myRank: { avatar: '', ratio: '', scroe: '', name: '', gender: '' },
      bottomLink: { img: '', url: '' },
      qrUrl: '',
      pagetype: 'userinfo',
      showInfo: true,
      showMyRank: true,
      showRank: false,
      appid: '',
      params: { code: '', appid: '' },
      showMyData: true,
      heightMeasure: 0,
      scalHeight: 0,
    }
  },
  created() {
    document.title = '智能体脂称'
    this.$loading.open({ text: '数据加载中' })

    let open_id = UrlParameter('open_id')
    if (open_id) {
      let timestamps = UrlParameter('timestamps')
      let platform = UrlParameter('platform')
      let sign = UrlParameter('sign')

      this.showMyData = false

      this.signReport({
        open_id,
        timestamps,
        platform,
        sign,
        per: 1,
        page: 1
      })
    } else {
      this.code = UrlParameter('code') || localStorage.getItem('code')
      this.appid = UrlParameter('appid')
      this.heightMeasure = UrlParameter('height_measure') == "1"

      this.params = {
        code: this.code
      }
      if (this.appid) {
        this.params.appid = this.appid
      }
      localStorage.setItem('code', this.code)

      this.getBanner()
      this.initReport()
      this.getRanking()
    }
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.$refs.box.style.height = window.innerHeight + 'px'
    })
  },
  watch: {},
  computed: {
    computeBirthday() {
      if (this.myInfo && this.myInfo.birthday) {
        return `${this.myInfo.birthday.year()}.${this.myInfo.birthday.month() + 1}.${this.myInfo.birthday.date()}`
      }
      return ''
    }
  },
  methods: {
    signReport(params) {
      console.log('执行了signReport')
      return ajax.get(api.get_history_dates, params).then(res => {
        let data = res.data
        if (data.code == 200) {
          console.log('signReport data', data)
          let measureData = data.data.rows[0]
          if (measureData.weight) {
            measureData = fillFlag(measureData)
          }
          this.drawMeasureData(data.data.user_data, measureData)
        } else {
          alert(res.msg)
        }
        this.$loading.close()
      })
    },
    initReport() {
      console.log('执行了initReport')
      let heightMeasure = this.heightMeasure
      ajax
        .post(heightMeasure ? api.height_measure : api.measure, this.params)
        .then(res => {
          console.log('历史数据', res)
          this.showRank = Boolean(res.data.rank_flag)
          // return
          if (res.data.code == '201') {
            this.haveWeight = false
            let url = `${api.editPage}?code=${this.code}`
            if (this.appid) {
              url += `&appid=${this.appid}`
            }
            url += `&height_measure=${+this.heightMeasure}`;
            window.location.href = url
          } else if (res.data.code == '200') {
            /* let { avatar_url, height, birthday, gender, account_name } = res.data.user_data
            this.userName = account_name
            this.userImage = avatar_url
            this.userInfo[0].height = height
            this.userInfo[0].birthday = birthday
            this.userInfo[0].sex = gender == 1 ? '男' : '女'
            this.haveWeight = true
            this.showMyRank = true
            this.setReportData(new Decoder(res.data.measre_data)) */
            this.drawMeasureData(res.data.user_data, res.data.measre_data)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    drawMeasureData(user_data, measre_data) {
      let { avatar_url, height, birthday, gender, account_name } = user_data

      this.userName = account_name
      this.userImage = avatar_url
      this.userInfo[0].height = height
      this.userInfo[0].birthday = birthday
      this.userInfo[0].sex = gender == 1 ? '男' : '女'
      this.haveWeight = true
      this.showMyRank = true
      this.heightMeasure && (measre_data.stature = measre_data.height)
      if (measre_data) {
        this.setReportData(new Decoder(measre_data))
      } else {
        alert('没有测量数据')
      }
    },
    setReportData(editData) {
      console.log('editDate', editData)
      this.myInfo = editData.measure
      this.userWeight = this.myInfo.weight
      let tmp1 = this.myInfo.measure_time._i.split(/-|\ /)
      this.weightTime = `${tmp1[0]}年${tmp1[1]}月${tmp1[2]}日 ${tmp1[3].slice(0, 5)}`
      this.score = this.myInfo.score
      this.until = editData.reportItemList[0].unit
      this.indexDatas = editData.reportItemList
      // 删除为0的元素值
      // for (let i = 0; i < editData.reportItemList.length; i++) {
      //   if (parseFloat(editData.reportItemList[i].value) < 0.01) {
      //     editData.reportItemList.splice(i, 1)
      //     i--
      //   }
      // }
      for (let i = 0; i < editData.reportItemList.length; i += 3) {
        this.datas.push(editData.reportItemList.slice(i, i + 3))
      }
      this.$loading.close()
    },
    onClickEditInfo() {
      const code = localStorage.getItem('code')
      let name = UrlParameter('name') || ''
      let url = `${window.location.protocol}//${window.location.host}/EditPage.html?name=${name}&code=${code}`
      if (this.appid) {
        url += `&appid=${this.appid}`
      }
      url += `&height_measure=${+this.heightMeasure}`;
      window.location.href = url
    },
    onClickHistory() {
      // 点击历史数据
      let url = window.location.href.split('?')
      window.location.href = `${window.location.protocol}//${window.location.host}/historyData.html?userName=${this.userName}&${url[1]}`
    },
    getRanking() {
      ajax
        .get(api.ranking, this.params)
        .then(res => {
          if (res.data.code === '200') {
            this.myRank = res.data.my
            this.haveWeight = !!res.data.my
            this.$set(this, 'rankList', res.data.ranking.length > 0 ? res.data.ranking.slice(0, 10) : [])
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    getBanner() {
      ajax.get(api.banner, this.params).then(res => {
        let data = res.data.data
        // console.log('ad 0', res, data.ads.length, data.ads)

        this.imgList = (data && data.ads.filter(item => {
          if (item.advert_type == 4 && item.device_type == 0) {
            this.bottomLink = item
            return false
          } else if (item.advert_type == 3&&item.device_type == 0) {
            return true
          }
          return false
        })) || [{ img: '', url: '' }]
      })
    }
  },
  components: {
    Headers,
    swiper,
    Measure,
    healthReport
  }
}
</script>

<style lang="scss">
@import '../../assets/css/px2rem';
@import '~@/assets/css/common.scss';
#app {
  box-sizing: border-box;
}
.user-info-box {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  position: relative;
}
.history-span {
  font-size: 14px !important;
  background-color: rgba(255, 255, 255, 0.2);
  width: rem(95);
  height: rem(30);
  display: flex;
  align-items: center;
  flex-flow: row nowrap;
  justify-content: space-between;
  &:before,
  &:after {
    content: '';
    display: block;
  }
  border-radius: rem(30) 0 0 rem(30);
  > img {
    width: rem(14);
    height: rem(14);
  }
}
.back {
  position: relative;
  width: 100%;
  height: rem(29);
  background: #383a40;
}
#user-info {
  width: 100%;
  height: 100%;
  -webkit-overflow-scrolling: touch;
  overflow-y: auto;
  background-color: #1fd2ba;
  position: relative;
}
.user_info_box {
  padding: 0 0.18rem;
  color: white;
  background: #1fd2ba;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  overflow: hidden;
  transition: height 0.5s;
  height: 1.75rem;
}
.user_info_title {
  height: 0.54rem;
  padding-top: 0.1rem;
  box-sizing: border-box;
  font-size: 16px;
  color: #5effdc;
  @extend .flex;
  @extend .flex-pack-justify;
  @extend .flex-align-center;
  img {
    width: 0.23rem;
    height: 0.22rem;
    position: absolute;
    top: 0;
    left: 50%;
    margin-left: -0.125rem;
  }
  .edit {
    background-image: url('/static/images/edit_icon.png');
    background-size: 100% 100%;
    width: 0.23rem;
    height: 0.23rem;
  }
}
.user_info {
  @extend .flex;
  @extend .flex-align-center;
  padding-bottom: 0.1rem;
  height: 1.2rem;
  position: relative;
  p {
    font-size: 15px;
    margin-bottom: 0.14rem;
    &:last-child {
      margin-bottom: 0;
    }
  }
  > div {
    display: inline-block;
    z-index: 1;
    position: relative;
  }
  .avatar {
    height: 0.5rem;
    width: 0.5rem;
    border-radius: 50%;
    margin-right: 0.18rem;
    margin-bottom: 0.14rem;
  }
  .background {
    position: absolute;
    right: -0.05rem;
    bottom: 0.05rem;
    width: 1.42rem;
    height: 1.12rem;
  }
}
.last-message {
  background-color: #18bdef;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 9999;
}
.last-message a {
  display: block;
  position: relative;
  height: rem(60);
  margin: 0 auto;
  background: no-repeat center;
  background-size: 100% auto;
}
@media (min-width: 340px) {
  .code-message span {
    display: inline-block;
    background: url('/static/images/triangle-right.png') no-repeat;
    background-size: 100% 100%;
    width: 8px;
    height: 10px;
    margin-left: 5px;
  }
}
/* 二维码样式*/
.code-back {
  background: #1fd2ba;
  width: 100%;
  padding-bottom: rem(20);
}
.code-box {
  position: relative;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  height: rem(90);
  padding: rem(10) rem(10);
  background-color: #27a496;
  border-radius: 0 0 rem(10) rem(10);
  @extend .flex;
  justify-content: space-around;
  color: #fff;
  margin: 0 rem(18);
  font-size: 0.13rem;
}
.code-box > div {
  display: inline-block;
}
.code {
  box-sizing: border-box;
  border: 1px dashed rgba(255, 255, 255, 0.45);
  padding: rem(2);
  position: absolute;
  right: rem(10);
  width: rem(70);
  height: rem(70);
}
.code img {
  width: 100%;
  height: 100%;
}
.code-text {
  /*height: 100%;*/
  position: absolute;
  left: rem(10);
}
.code-title {
  font-size: 18px;
  margin-bottom: rem(16);
}
.code-message {
  position: relative;
  font-size: 15px;
  bottom: 0;
}
.btn-share {
  border: none;
  outline: none;
  position: fixed;
  background: url('/static/images/share-btn.png') no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
  width: 0.55rem;
  height: 0.55rem;
  bottom: 0.5rem;
  right: 0.15rem;
  z-index: 9999;
}
.health-tips {
  text-align: center;
  color: #fff;
  font-size: 0.15rem;
  line-height: 0.25rem;
  background: #18bdef;
  padding-bottom: 0.1rem;
}
.user-content {
  width: 100%;
  box-sizing: border-box;
  border-radius: rem(15) rem(15) 0 0;
  position: relative;
  overflow: hidden;
  margin-top: rem(-15);
}
/* 用户信息 start*/

/* 健康报告样式 start*/
.content-last {
  width: 100%;
  background-color: #fdaa09;
}
.content-last .content-last-info {
  width: 100%;
  background-color: #18bdef;
  border-radius: 0.15rem 0.15rem 0 0;
  padding-left: 0.18rem;
  box-sizing: border-box;
}
.last-first {
  width: 100%;
  height: 0.54rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.last-first span {
  margin-top: 0.24rem;
  color: #c2f6ff;
  font-size: 0.16rem;
}
.all-bottom {
  background-color: #18bdef;
  height: 0.83rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue